var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckEmailIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6018,
    cy: 10.8049,
    r: 10.6018,
    fill: "#3583EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52649 13.3808L6.63939 10.4817L5.65625 11.4619L9.52649 15.3483L16.6618 8.24083L15.6926 7.27344L9.52649 13.3808Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckEmailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckEmailIcon.3decd8b3.svg";
export { ForwardRef as ReactComponent };